import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface DeclineInvoiceRequest {
  invoiceIds?: any[];
}

export interface DeclineApiResponseData {
  processedIds: number[];
  unProcessed:
    | {
        id: number;
        errorMessage: string;
      }[]
    | [];
}

const useDeclineInvoiceApi = () => {
  const call = useCallback(async (params?: DeclineInvoiceRequest | undefined) => {
    try {
      if (isEmpty(params?.invoiceIds)) {
        throw new Error('invoiceIds empty');
      }
      const res = await axiosInstance.post(api.declineInvoice, params?.invoiceIds);
      return res.data as DeclineApiResponseData;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute, status } = useAsync<DeclineApiResponseData, DeclineInvoiceRequest>(
    call,
    false
  );

  return { declineInvoice: execute, declineCallLoading: isLoading, status };
};

export default useDeclineInvoiceApi;
